var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-visitor-timer"},[_c('b-tooltip',{attrs:{"label":_vm.formattedVisitStartDate,"type":"is-info"}},[_vm._v(" "+_vm._s(_vm.runningTime)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }